<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-4">
    <label for="r017_itemType">Solicitante</label>
    <input id="r017_requester" type="text" pInputText [(ngModel)]="filters.requester" />
  </div>

  <div class="field col-12 md:col-4">
    <label for="r017_itemType">Tipo de peça</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown
      id="r017_itemType"
      [options]="comboOptions.itemType"
      [(ngModel)]="filters.itemType"
      placeholder="Todos"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
      [showClear]="true"
      *ngIf="!isLoadingComboOptions"
    ></p-dropdown>
  </div>

  <div class="field col-12 md:col-4">
    <label for="r017_actionComunication">Ação de comunicação</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown
      id="r017_actionComunication"
      [options]="comboOptions.actionComunication"
      [(ngModel)]="filters.actionComunication"
      placeholder="Todos"
      optionLabel="label"
      optionValue="value"
      [filter]="true"
      filterBy="label"
      [showClear]="true"
      *ngIf="!isLoadingComboOptions"
    ></p-dropdown>
  </div>
</div>
